import { Link } from 'react-router-dom';

const IndustrialServices = () => {
  const services = [
    {
      icon: 'ri-flashlight-line',
      title: 'Three-Phase Installations',
      description: 'Complete three-phase power system design and installation for industrial facilities. We deliver high-capacity electrical infrastructure that supports demanding operational requirements.',
      includes: [
        'Three-phase power distribution',
        'High-voltage installations',
        'Load calculation and design',
        'Transformer installations',
        'Power factor correction',
        'System commissioning',
      ],
      image: 'https://public.readdy.ai/ai/img_res/61d9515bd92258aefbefe4f5c363dd80.jpg',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Motor &amp; Machinery Connections',
      description: 'Expert installation and connection of industrial motors, machinery and production equipment. We ensure reliable power delivery and safe operation for all industrial equipment.',
      includes: [
        'Motor starter installations',
        'Variable speed drive setup',
        'Machinery power connections',
        'Equipment commissioning',
        'Load testing and verification',
        'Safety interlocking systems',
      ],
      image: 'https://readdy.ai/api/search-image?query=industrial%20motor%20and%20machinery%20electrical%20connections%20with%20variable%20speed%20drives%20and%20control%20systems%20in%20factory%20showing%20professional%20installation%20work%20and%20organized%20wiring%20with%20safety%20compliance&width=700&height=500&seq=ind-motors&orientation=landscape',
    },
    {
      icon: 'ri-cpu-line',
      title: 'Control Panel Wiring',
      description: 'Custom control panel design, fabrication and wiring for industrial automation and process control. We build reliable control systems that meet your operational specifications.',
      includes: [
        'Control panel design',
        'PLC integration',
        'Instrumentation wiring',
        'HMI installations',
        'Panel fabrication',
        'System documentation',
      ],
      image: 'https://readdy.ai/api/search-image?query=industrial%20electrical%20control%20panel%20with%20PLC%20systems%20organized%20wiring%20and%20automation%20equipment%20showing%20professional%20panel%20fabrication%20and%20technical%20installation%20work%20with%20clean%20cable%20management&width=700&height=500&seq=ind-controlpanel&orientation=landscape',
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Preventative Maintenance',
      description: 'Scheduled maintenance programs to maximise uptime and prevent costly equipment failures. Our systematic approach identifies issues before they impact production.',
      includes: [
        'Scheduled inspections',
        'Thermal imaging surveys',
        'Connection testing',
        'Equipment servicing',
        'Predictive maintenance',
        'Detailed reporting',
      ],
      image: 'https://readdy.ai/api/search-image?query=electrician%20performing%20preventative%20maintenance%20inspection%20on%20industrial%20electrical%20equipment%20with%20thermal%20imaging%20camera%20and%20testing%20tools%20in%20manufacturing%20facility%20showing%20professional%20maintenance%20service&width=700&height=500&seq=ind-maintenance&orientation=landscape',
    },
    {
      icon: 'ri-search-line',
      title: 'Fault Diagnostics &amp; Testing',
      description: 'Advanced diagnostic services using specialised testing equipment to identify and resolve electrical faults quickly, minimising production downtime.',
      includes: [
        'Power quality analysis',
        'Circuit testing',
        'Equipment diagnostics',
        'Fault location services',
        'Emergency response',
        'Repair and rectification',
      ],
      image: 'https://readdy.ai/api/search-image?query=industrial%20electrician%20using%20advanced%20diagnostic%20testing%20equipment%20and%20power%20quality%20analyzer%20in%20factory%20setting%20showing%20professional%20fault%20finding%20and%20technical%20troubleshooting%20work&width=700&height=500&seq=ind-diagnostics&orientation=landscape',
    },
    {
      icon: 'ri-dashboard-2-line',
      title: 'Switchboard Upgrades',
      description: 'Industrial switchboard installations and upgrades to support increased capacity and modern safety standards. We design systems for reliability and future expansion.',
      includes: [
        'Main switchboard installations',
        'Distribution board upgrades',
        'Busbar systems',
        'Protection coordination',
        'Capacity upgrades',
        'Compliance certification',
      ],
      image: 'https://readdy.ai/api/search-image?query=large%20industrial%20electrical%20switchboard%20installation%20with%20organized%20circuit%20breakers%20busbar%20systems%20and%20safety%20equipment%20in%20manufacturing%20facility%20showing%20professional%20upgrade%20work%20and%20compliance&width=700&height=500&seq=ind-switchboard&orientation=landscape',
    },
  ];

  return (
    <section>
      {services.map((service, index) => (
        <div
          key={index}
          className={`py-20 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
        >
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <div className="w-14 h-14 flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-gold text-6xl`}></i>
                </div>
                <h2 className="text-4xl font-bold text-navy mb-6">{service.title}</h2>
                <div className="h-0.5 w-20 bg-gold mb-8"></div>

                <p className="text-charcoal text-base leading-relaxed mb-8">
                  {service.description}
                </p>

                <h3 className="text-navy font-bold text-lg mb-4">Includes:</h3>
                <ul className="space-y-3 mb-8">
                  {service.includes.map((item, iIndex) => (
                    <li key={iIndex} className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-gold text-xl mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                      <span className="text-charcoal">{item}</span>
                    </li>
                  ))}
                </ul>

                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 border-2 border-navy text-navy px-8 py-3 rounded-lg font-bold text-sm tracking-wider hover:bg-navy hover:text-white transition-all whitespace-nowrap cursor-pointer"
                >
                  REQUEST A QUOTE
                </Link>
              </div>

              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <div className="relative">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-auto rounded-lg shadow-lg border-4 border-gold object-cover"
                    style={{ objectPosition: 'center' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
};

export default IndustrialServices;